import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Masonry } from '../common';
import { ApiDefinition } from '../../types/api-definitions';
import ApiCard from './ApiCard';
import { getLocalizedContent } from '../../utils/apiUtils';
import { Language } from '@/types';

interface ApiPortalContentProps {
  apiDefinitions: ApiDefinition[];
}

const ApiPortalContent: React.FC<ApiPortalContentProps> = ({ apiDefinitions: apiDefinitions }) => {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.language as Language;

  const sortedApiDefinitions = useMemo(() => {
    return [...apiDefinitions]
      .filter((api) => api.authoredContent)
      .sort((a, b) => {
        const contentA = getLocalizedContent(a, selectedLanguage);
        const contentB = getLocalizedContent(b, selectedLanguage);
        const titleA = contentA?.title || '';
        const titleB = contentB?.title || '';
        return titleA.localeCompare(titleB, selectedLanguage, { sensitivity: 'base' });
      });
  }, [apiDefinitions, selectedLanguage]);

  return (
    <Box sx={{ flex: 1, p: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant='h1'>{t('apiPortalContent.title')}</Typography>
        <Typography variant='body1' color='text.secondary'>
          {t('apiPortalContent.description')}
        </Typography>
      </Box>
      <Masonry columns={{ xs: 1, md: 2 }} spacing={2}>
        {sortedApiDefinitions.map((api) => (
          <ApiCard key={api.id} apiDefinition={api} />
        ))}
      </Masonry>
    </Box>
  );
};

export default ApiPortalContent;
